import {
  NumberParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params';

export default function usePaginationQueryParams() {
  const [offset, setOffset] = useQueryParam(
    'offset',
    withDefault(NumberParam, null),
    { updateType: 'replaceIn' }
  );
  const [orderBy, setOrderBy] = useQueryParam(
    'order_by',
    withDefault(StringParam, ''),
    { updateType: 'replaceIn' }
  );
  const [orderDir, setOrderDir] = useQueryParam(
    'order_dir',
    withDefault(StringParam, ''),
    { updateType: 'replaceIn' }
  );

  return {
    offset,
    orderBy,
    orderDir,
    setOffset,
    setOrderBy,
    setOrderDir,
  };
}
